<template>
  <section class="calling-screen">
    <div class="profile-part">
      <span class="caller-img">
        <img :src="(callerImg === 'avatar1' || !callerImg) ? 'https://images.unsplash.com/photo-1487412720507-e7ab37603c6f?ixlib=rb-1.2.1&ixid=eyJhcHBfaWQiOjEyMDd9&auto=format&fit=crop&w=1000&q=80' : callerImg"  alt="">
      </span>
      <span class="Connecting" >{{message}}</span>
      <span class="call-timing"  v-if="(!showReconnect && callStatus === 'call_initiate')">
           <label id="minutes">{{ Minutes }}</label
          >:<label id="seconds">{{ Seconds }}</label>
      </span>
      <span class="Connecting" v-if="(!internetDisconnect && (callStatus === 'call_received'))">{{$t('Connecting')}}</span>
      <span class="Connecting" v-if="(internetDisconnect || showReconnect )">{{$t('Re-connecting')}}</span>
    </div>
    <div class="calling-tools">
      <div class="inner">
        <span :class="micOn ? 'mute' : 'mute active'" @click="Mute"> 
          {{$t('Mute')}}
        </span> 
        <span :class="(internetDisconnect || disconnectBtn) ? 'call-btn desable' : 'call-btn'" @click="CallDisconnect">
          <img :src='require("../../assets/images/call-btn.svg")' alt="">
        </span>
        <span :class="speakerOn ? 'speaker active' : 'speaker'" @click="Speaker">
          {{$t('Speaker')}}
        </span>
      </div>
    </div>
  </section>
</template>
<script>
export default {
  name: "CallReceived",
  data(){
    return{
      disconnectBtn: false,
      checked: false
    }
  },
  props: {
      callerImg: String,
      Seconds: String,
      Minutes: String,
      callStatus: String,
      speakerOn: Boolean,
      micOn: Boolean,
      remoteStreamNotFound: Boolean,
      reconnecting_status: String,
      showReconnect: Boolean,
      internetDisconnect: Boolean,
      message: String
  },
  methods:{
      CallDisconnect(){
       this.disconnectBtn = true
       this.$emit('CallDisconnect')
      },
      Mute(){
        this.$emit('Mute')
      },
      Speaker(){
        this.$emit('Speaker')
      }
  },
  mounted(){
      console.log('==call received mounted==')
  }
}
</script>